"use client";

import { useRef, type ReactNode } from "react";

import { cn } from "@/lib/utils";

import { useInViewOnce } from "./useInViewOnce";

type InViewMarkProps = {
  children: ReactNode;
  className?: string;
  as?: "div" | "li" | "blockquote";
  rootMargin?: string;
};

/**
 * Sets `data-inview` once the element scrolls into view, so CSS can run a
 * one-time reveal (crop marks closing in, metrics rolling).
 */
export const InViewMark = ({
  children,
  className,
  as: Tag = "div",
  rootMargin,
}: InViewMarkProps) => {
  const ref = useRef<HTMLElement>(null);
  const inView = useInViewOnce(ref, rootMargin);
  return (
    <Tag
      ref={ref as never}
      data-inview={inView ? "" : undefined}
      className={cn(className)}
    >
      {children}
    </Tag>
  );
};
